// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info-popper_wrapper__Tv4g6 {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user-info-popper_cardWrapper__gmHKI {
  box-shadow: none;
  border: 1px solid var(--mui-palette-grey-400);
  border-radius: 6px;
  margin-top: 10px;
  background-color: var(--mui-palette-secondary-50);
}`, "",{"version":3,"sources":["webpack://./src/components/most/list/filter/user-info-popper.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.cardWrapper {\n  box-shadow: none;\n  border: 1px solid var(--mui-palette-grey-400);\n  border-radius: 6px;\n  margin-top: 10px;\n  background-color: var(--mui-palette-secondary-50);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `user-info-popper_wrapper__Tv4g6`,
	"cardWrapper": `user-info-popper_cardWrapper__gmHKI`
};
export default ___CSS_LOADER_EXPORT___;
